module.exports = __webpack_public_path__ + "img/bg.63a71110.png";